import { Base } from './_base';

export class ListBackend extends Base {
  constructor(item) {
    super(item);
  }
}
